function createPlayerProgression(login, progression){
    var request = new XMLHttpRequest();
    request.open('POST', './backend/sauvegardes/create.php', true);
    request.onload = function () {
        try{
            var data = JSON.parse(this.response);
        }catch{
            console.log("error save")
        }
    }
    console.log("svg :",JSON.stringify({
        login: login,
        progression: JSON.stringify(progression)
    }))
    request.send(JSON.stringify({
        login: login,
        progression: JSON.stringify(progression)
    }));
}

function readPlayerProgression(login, endFunc){
    var request = new XMLHttpRequest();
    request.open('POST', './backend/sauvegardes/read.php', true);
    request.onload = function () {
        try{
            var data = JSON.parse(this.response);
            endFunc(data)
        }catch{
            endFunc({})
        }

    }
    request.send(JSON.stringify({
        login: login,
    }));
}

function readAll(endFunc){
    var request = new XMLHttpRequest();
    request.open('POST', './backend/sauvegardes/readAll.php', true);
    request.onload = function () {
        try{
            var data = JSON.parse(this.response);
            endFunc(data)
        }catch{
            endFunc({})
        }
    }
    request.send("");
}

function increaseConnection(login){
    var request = new XMLHttpRequest();
    request.open('POST', './backend/sauvegardes/increaseConnection.php', true);
    request.onload = function () {
        try{
            var data = JSON.parse(this.response);
        }catch{
            console.log("error save")
        }

    }
    request.send(JSON.stringify({
        login: login,
    }));
}

function doProgressionExists(login, endFunc){
    readPlayerProgression(login, (data) => {
        console.log("doProgressionExists data :", data);
        endFunc(data.length > 0);
    });
}

function updatePlayerProgression(login, progression){
    var request = new XMLHttpRequest();
    request.open('POST', './backend/sauvegardes/update.php', true);
    request.onload = function () {
        try{
            var data = JSON.parse(this.response);
        }catch{
            console.log("error save")
        }
    }
    request.send(JSON.stringify({
        login: login,
        progression: JSON.stringify(progression)
    }));
}

export {
    createPlayerProgression,
    readPlayerProgression,
    readAll,
    doProgressionExists,
    updatePlayerProgression,
    increaseConnection
}